import React from "react"
import clsx from "clsx"

import Button from "@components/ui/Button/Button"
import Icon from "@components/ui/Icon/Icon"
import Loader from "../Loader/BarLoader"

import sizeStyles from "./FileCard-size.module.sass"
import styles from "./index.module.sass"

interface FileCardProps {
  name?: string
  onRemove?: React.MouseEventHandler
  loading?: boolean
  size?: "big" | "medium" | "small"
  disabled?: boolean
}

const FileCard: React.FC<FileCardProps> = ({
  name,
  onRemove,
  loading = false,
  size = "medium",
  disabled,
}) => {
  const handleRemove: React.MouseEventHandler = (event) => {
    event.preventDefault()
    event.stopPropagation()
    // Always allow remove — loading/disabled must not trap the chip on screen
    onRemove?.(event)
  }

  return (
    <div
      className={clsx(styles.root, sizeStyles[size], {
        [styles.disabled]: disabled,
      })}
    >
      {loading && <Loader size="small" />}
      <span className={styles.name} title={name}>
        {name}
      </span>
      {onRemove != null && (
        <Button
          type="button"
          tabIndex={0}
          aria-label={`Remove ${name || "attachment"}`}
          title="Remove attachment"
          color="secondary"
          variant="text"
          size="tiny"
          noPadding
          className={styles.remove}
          onMouseDown={handleRemove}
          onClick={handleRemove}
        >
          <Icon name="cross" />
        </Button>
      )}
    </div>
  )
}

export default FileCard
